import clearDay from "assets/images/clear-day.svg";
import cloudy from "assets/images/cloudy.svg";
import partlyCloudyDay from "assets/images/partly-cloudy-day.svg";
import rain from "assets/images/rain.svg";

/** Condições climáticas usadas no RDO (ícones locais). */
export type WeatherIconKey = "clear-day" | "partly-cloudy-day" | "cloudy" | "rain";

export const WEATHER_ICONS: Record<WeatherIconKey, string> = {
  "clear-day": clearDay,
  "partly-cloudy-day": partlyCloudyDay,
  cloudy,
  rain,
};

export function getWeatherIconSrc(key?: WeatherIconKey | null): string {
  if (key && WEATHER_ICONS[key]) return WEATHER_ICONS[key];
  return WEATHER_ICONS["partly-cloudy-day"];
}

/** Skeleton sem API: ícone neutro (com dados, usar getDailyWeatherIcon). */
export function placeholderWeatherIconKey(_index: number): WeatherIconKey {
  return "clear-day";
}
